export enum ProductType {
  Classic = 'classic',
  Smart = 'smart',
  Premium = 'premium',
  Basic = 'basic',
  PremiumPlus = 'premium_plus',
}
